export default "__VITE_ASSET__C58OD_xE__"